/**
 * NAKED Size Widget - Fichier de traductions multilingue (version complète)
 * Version: 1.0.0
 * Dernière mise à jour: Mai 2025
 */

// Ce fichier est inclus deux fois sur les fiches produit (bloc « Widget de Taille NAKED » des modèles + snippet
// naked-size-recommender). La 2e exécution plantait sur « checkInterval already declared » et ne faisait rien :
// garde explicite, même comportement (une seule exécution), sans l'erreur JS.
if (!window.__nakedSizeTranslationsLoaded) {
window.__nakedSizeTranslationsLoaded = true;
(function() {
  'use strict';
  
  // Détection automatique de la langue : locale réelle de la page d'abord
  // (Shopify pose <html lang="de|nl|da|sv|fr">), puis sous-domaine en secours.
  // Indispensable pour be.naked-underwear.com qui sert le français ET /da (danois).
  function detectLanguage() {
    const docLang = ((document.documentElement && document.documentElement.getAttribute('lang')) || '')
      .toLowerCase().slice(0, 2);
    if (docLang && translations[docLang]) return docLang;

    const hostname = window.location.hostname;
    const pathname = (window.location.pathname || '');

    if (hostname.startsWith('fr.')) return 'fr';
    if (hostname.startsWith('us.') || hostname.startsWith('en.')) return 'en';
    if (hostname.startsWith('uk.')) return 'en';
    if (hostname.startsWith('de.')) return 'de';
    if (hostname.startsWith('nl.')) return 'nl';
    if (hostname.startsWith('it.')) return 'it';
    if (hostname.startsWith('se.')) return 'sv';
    if (hostname.startsWith('da.')) return 'da';
    if (hostname.startsWith('be.')) {
      if (pathname === '/da' || pathname.startsWith('/da/')) return 'da';
      return 'fr';
    }
    if (hostname.startsWith('aus.')) return 'en';

    // Le domaine principal naked-underwear.com utilise le français par défaut
    if (hostname === 'naked-underwear.com' || hostname.endsWith('naked-underwear.com')) {
      return 'fr';
    }

    // Par défaut - francais
    return 'fr';
  }
  
  // Définition de toutes les traductions
  const translations = {
    // Français
    'fr': {
      // Général
      'calculate_size': 'Calculer ma taille',
      'brand_name': 'NAKED UNDERWEAR',
      'next': 'Suivant',
      'previous': 'Précédent',
      'close': 'Fermer',
      
      // Bouton d'affichage de taille
      'size_button_with_size': 'Votre taille parfaite pour cet ensemble est',
      'size_button_with_body_size': 'Votre taille parfaite pour ce body est',
      
      // Texte de taille sur la page produit
      'size_notice': 'Votre taille parfaite pour cet ensemble est',
      'size_notice_body': 'Votre taille parfaite pour ce body est',
      
      // Unités
      'cm': 'cm',
      'feet': 'pieds',
      'kg': 'kg',
      'lbs': 'livres',
      'years': 'ans',
      
      // Étape 1
      'step1_title': 'RENSEIGNEZ QUELQUES INFORMATIONS CI-DESSOUS :',
      'height': 'TAILLE',
      'weight': 'POIDS',
      'age': 'ÂGE',
      
      // Étape 2
      'step2_title': 'QUEL VENTRE RESSEMBLE LE PLUS AU VÔTRE ?',
      'stomach_flat': 'Plat',
      'stomach_average': 'Moyen',
      'stomach_round': 'Avec des rondeurs',
      
      // Étape 3
      'step3_title': 'QUELLES HANCHES RESSEMBLENT LE PLUS AUX VÔTRES ?',
      'hips_narrow': 'Étroites',
      'hips_average': 'Moyennes',
      'hips_curved': 'Courbées',
      
      // Étape 4
      'step4_title': 'QUELLES FESSES RESSEMBLENT LE PLUS AUX VÔTRES ?',
      'seat_flat': 'Plates',
      'seat_average': 'Moyennes',
      'seat_round': 'Rondes',
      
      // Étape 5
      'step5_title': 'SÉLECTIONNEZ VOTRE TAILLE DE SOUTIEN-GORGE',
      'region_eu': 'EUROPE (FR, IT, ES, DE)',
      'region_uk': 'ROYAUME-UNI',
      'region_us': 'ÉTATS-UNIS',
      'region_aus': 'AUSTRALIE',
      'band_size': 'TOUR DE DOS',
      'cup_size': 'BONNET',
      
      // Étape 6
      'step6_title': 'SÉLECTIONNEZ VOTRE TAILLE DE BAS HABITUELLE',
      'size': 'TAILLE',
      'see_recommendation': 'Voir ma recommandation',
      
      // Étape 7
      'step7_title': 'VOTRE TAILLE IDÉALE',
      'size_label': 'TAILLE :',
      'top_size': 'HAUT :',
      'bottom_size': 'BAS :',
      'body_explanation': 'Pour un body, nous recommandons une taille qui s\'adaptera parfaitement à votre morphologie.',
      'social_proof_body': 'Nos clientes ayant votre morphologie choisissent cette taille',
      'social_proof_ensemble': 'Nos clientes ayant votre morphologie choisissent ces tailles pour leur ensemble',
      'edit_answers': 'Modifier mes réponses',
      'continue': 'Continuer',
      'step7_title_body': 'VOTRE TAILLE DE BODY IDÉALE',
      'apply_size': 'Appliquer cette taille',
      'apply_size_aria': 'Appliquer la taille',

      // Messages d'erreur et de validation
      'fill_all_fields': 'Veuillez remplir correctement tous les champs.',
      'select_option': 'Veuillez sélectionner une option.',
      'select_band_cup': 'Veuillez sélectionner une taille de tour de dos et un bonnet.',
      'select_bottom_size': 'Veuillez sélectionner une taille de bas.'
    },
    
    // Anglais (base - utilisé pour US, UK et AUS)
    'en': {
      // Général
      'calculate_size': 'Find my size',
      'brand_name': 'NAKED UNDERWEAR',
      'next': 'Next',
      'previous': 'Back',
      'close': 'Close',
      
      // Bouton d'affichage de taille
      'size_button_with_size': 'Your perfect size for this set is',
      'size_button_with_body_size': 'Your perfect size for this bodysuit is',
      
      // Texte de taille sur la page produit
      'size_notice': 'Your perfect size for this set is',
      'size_notice_body': 'Your perfect size for this bodysuit is',
      
      // Unités
      'cm': 'cm',
      'feet': 'feet',
      'kg': 'kg',
      'lbs': 'lbs',
      'years': 'years',
      
      // Étape 1
      'step1_title': 'PLEASE ENTER THE FOLLOWING INFORMATION:',
      'height': 'HEIGHT',
      'weight': 'WEIGHT',
      'age': 'AGE',
      
      // Étape 2
      'step2_title': 'WHICH STOMACH SHAPE LOOKS MOST LIKE YOURS?',
      'stomach_flat': 'Flat',
      'stomach_average': 'Average',
      'stomach_round': 'Rounded',
      
      // Étape 3
      'step3_title': 'WHICH HIP SHAPE LOOKS MOST LIKE YOURS?',
      'hips_narrow': 'Narrow',
      'hips_average': 'Average',
      'hips_curved': 'Curved',
      
      // Étape 4
      'step4_title': 'WHICH BUTTOCKS SHAPE LOOKS MOST LIKE YOURS?',
      'seat_flat': 'Flat',
      'seat_average': 'Average',
      'seat_round': 'Round',
      
      // Étape 5
      'step5_title': 'SELECT YOUR BRA SIZE',
      'region_eu': 'EUROPE (FR, IT, ES, DE)',
      'region_uk': 'UNITED KINGDOM',
      'region_us': 'UNITED STATES',
      'region_aus': 'AUSTRALIA',
      'band_size': 'BAND SIZE',
      'cup_size': 'CUP SIZE',
      
      // Étape 6
      'step6_title': 'SELECT YOUR USUAL BOTTOM SIZE',
      'size': 'SIZE',
      'see_recommendation': 'See my recommendation',
      
      // Étape 7
      'step7_title': 'YOUR PERFECT SIZE',
      'size_label': 'SIZE:',
      'top_size': 'TOP:',
      'bottom_size': 'BOTTOM:',
      'body_explanation': 'For a bodysuit, we recommend a size that will perfectly fit your body shape.',
      'social_proof_body': 'Customers with your body shape choose this size',
      'social_proof_ensemble': 'Customers with your body shape choose these sizes for their set',
      'edit_answers': 'Edit my answers',
      'continue': 'Continue',
      'step7_title_body': 'YOUR PERFECT BODYSUIT SIZE',
      'apply_size': 'Apply this size',
      'apply_size_aria': 'Apply size',
      
      // Messages d'erreur et de validation
      'fill_all_fields': 'Please fill in all fields correctly.',
      'select_option': 'Please select an option.',
      'select_band_cup': 'Please select a band size and cup size.',
      'select_bottom_size': 'Please select a bottom size.'
    },
    
    // Allemand
    'de': {
      // Général
      'calculate_size': 'Meine Größe berechnen',
      'brand_name': 'NAKED UNDERWEAR',
      'next': 'Weiter',
      'previous': 'Zurück',
      'close': 'Schließen',
      
      // Bouton d'affichage de taille
      'size_button_with_size': 'Ihre perfekte Größe für dieses Set ist',
      'size_button_with_body_size': 'Ihre perfekte Größe für diesen Body ist',

      // Texte de taille sur la page produit
      'size_notice': 'Ihre perfekte Größe für dieses Set ist',
      'size_notice_body': 'Ihre perfekte Größe für diesen Body ist',
      
      // Unités
      'cm': 'cm',
      'feet': 'Fuß',
      'kg': 'kg',
      'lbs': 'Pfund',
      'years': 'Jahre',
      
      // Étape 1
      'step1_title': 'BITTE GEBEN SIE DIE FOLGENDEN INFORMATIONEN EIN:',
      'height': 'GRÖSSE',
      'weight': 'GEWICHT',
      'age': 'ALTER',
      
      // Étape 2
      'step2_title': 'WELCHE BAUCHFORM ÄHNELT IHRER AM MEISTEN?',
      'stomach_flat': 'Flach',
      'stomach_average': 'Durchschnittlich',
      'stomach_round': 'Gerundet',
      
      // Étape 3
      'step3_title': 'WELCHE HÜFTFORM ÄHNELT IHRER AM MEISTEN?',
      'hips_narrow': 'Schmal',
      'hips_average': 'Durchschnittlich',
      'hips_curved': 'Kurvig',
      
      // Étape 4
      'step4_title': 'WELCHE GESÄSSFORM ÄHNELT IHRER AM MEISTEN?',
      'seat_flat': 'Flach',
      'seat_average': 'Durchschnittlich',
      'seat_round': 'Rund',
      
      // Étape 5
      'step5_title': 'WÄHLEN SIE IHRE BH-GRÖSSE',
      'region_eu': 'EUROPA (FR, IT, ES, DE)',
      'region_uk': 'VEREINIGTES KÖNIGREICH',
      'region_us': 'VEREINIGTE STAATEN',
      'region_aus': 'AUSTRALIEN',
      'band_size': 'UNTERBRUSTUMFANG',
      'cup_size': 'KÖRBCHENGRÖSSE',
      
      // Étape 6
      'step6_title': 'WÄHLEN SIE IHRE ÜBLICHE UNTERGRÖSSE',
      'size': 'GRÖSSE',
      'see_recommendation': 'Meine Empfehlung anzeigen',
      
      // Étape 7
      'step7_title': 'IHRE PERFEKTE GRÖSSE',
      'size_label': 'GRÖSSE:',
      'top_size': 'OBERTEIL:',
      'bottom_size': 'UNTERTEIL:',
      'body_explanation': 'Für einen Body empfehlen wir eine Größe, die perfekt zu Ihrer Körperform passt.',
      'social_proof_body': 'Kundinnen mit Ihrer Körperform wählen diese Größe',
      'social_proof_ensemble': 'Kundinnen mit Ihrer Körperform wählen diese Größen für ihr Set',
      'edit_answers': 'Meine Antworten bearbeiten',
      'continue': 'Fortsetzen',
      'step7_title_body': 'IHRE PERFEKTE BODY-GRÖSSE',
      'apply_size': 'Diese Größe übernehmen',
      'apply_size_aria': 'Größe übernehmen',

      // Messages d'erreur et de validation
      'fill_all_fields': 'Bitte füllen Sie alle Felder korrekt aus.',
      'select_option': 'Bitte wählen Sie eine Option.',
      'select_band_cup': 'Bitte wählen Sie einen Unterbrustumfang und eine Körbchengröße.',
      'select_bottom_size': 'Bitte wählen Sie eine Untergröße.'
    },
    
    // Néerlandais
    'nl': {
      // Général
      'calculate_size': 'Mijn maat berekenen',
      'brand_name': 'NAKED UNDERWEAR',
      'next': 'Volgende',
      'previous': 'Vorige',
      'close': 'Sluiten',
      
      // Bouton d'affichage de taille
      'size_button_with_size': 'Jouw perfecte maat voor deze set is',
      'size_button_with_body_size': 'Jouw perfecte maat voor deze body is',
      
      // Texte de taille sur la page produit
      'size_notice': 'Jouw perfecte maat voor deze set is',
      'size_notice_body': 'Jouw perfecte maat voor deze body is',
      
      // Unités
      'cm': 'cm',
      'feet': 'voet',
      'kg': 'kg',
      'lbs': 'pond',
      'years': 'jaar',
      
      // Étape 1
      'step1_title': 'VUL DE VOLGENDE INFORMATIE IN:',
      'height': 'LENGTE',
      'weight': 'GEWICHT',
      'age': 'LEEFTIJD',
      
      // Étape 2
      'step2_title': 'WELKE BUIKVORM LIJKT HET MEEST OP DIE VAN JOU?',
      'stomach_flat': 'Plat',
      'stomach_average': 'Gemiddeld',
      'stomach_round': 'Rond',
      
      // Étape 3
      'step3_title': 'WELKE HEUPVORM LIJKT HET MEEST OP DIE VAN JOU?',
      'hips_narrow': 'Smal',
      'hips_average': 'Gemiddeld',
      'hips_curved': 'Gebogen',
      
      // Étape 4
      'step4_title': 'WELKE BILVORM LIJKT HET MEEST OP DIE VAN JOU?',
      'seat_flat': 'Plat',
      'seat_average': 'Gemiddeld',
      'seat_round': 'Rond',
      
      // Étape 5
      'step5_title': 'SELECTEER JE BH-MAAT',
      'region_eu': 'EUROPA (FR, IT, ES, DE)',
      'region_uk': 'VERENIGD KONINKRIJK',
      'region_us': 'VERENIGDE STATEN',
      'region_aus': 'AUSTRALIË',
      'band_size': 'OMVANG',
      'cup_size': 'CUPMAAT',
      
      // Étape 6
      'step6_title': 'SELECTEER JE GEBRUIKELIJKE ONDERMAAT',
      'size': 'MAAT',
      'see_recommendation': 'Bekijk mijn aanbeveling',
      
      // Étape 7
      'step7_title': 'JOUW PERFECTE MAAT',
      'size_label': 'MAAT:',
      'top_size': 'BOVENSTUK:',
      'bottom_size': 'ONDERSTUK:',
      'body_explanation': 'Voor een body raden we een maat aan die perfect bij jouw lichaamsvorm past.',
      'social_proof_body': 'Klanten met jouw lichaamsvorm kiezen deze maat',
      'social_proof_ensemble': 'Klanten met jouw lichaamsvorm kiezen deze maten voor hun set',
      'edit_answers': 'Mijn antwoorden bewerken',
      'continue': 'Doorgaan',
      'step7_title_body': 'JOUW PERFECTE BODY-MAAT',
      'apply_size': 'Deze maat toepassen',
      'apply_size_aria': 'Maat toepassen',

      // Messages d'erreur et de validation
      'fill_all_fields': 'Vul alle velden correct in.',
      'select_option': 'Selecteer een optie.',
      'select_band_cup': 'Selecteer een omvang en cupmaat.',
      'select_bottom_size': 'Selecteer een ondermaat.'
    },

    // Danois
    'da': {
      // Général
      'calculate_size': 'Beregn min størrelse',
      'brand_name': 'NAKED UNDERWEAR',
      'next': 'Næste',
      'previous': 'Tilbage',
      'close': 'Luk',

      // Bouton d'affichage de taille
      'size_button_with_size': 'Din perfekte størrelse til dette sæt er',
      'size_button_with_body_size': 'Din perfekte størrelse til denne body er',

      // Texte de taille sur la page produit
      'size_notice': 'Din perfekte størrelse til dette sæt er',
      'size_notice_body': 'Din perfekte størrelse til denne body er',

      // Unités
      'cm': 'cm',
      'feet': 'fod',
      'kg': 'kg',
      'lbs': 'pund',
      'years': 'år',

      // Étape 1
      'step1_title': 'UDFYLD VENLIGST FØLGENDE OPLYSNINGER:',
      'height': 'HØJDE',
      'weight': 'VÆGT',
      'age': 'ALDER',

      // Étape 2
      'step2_title': 'HVILKEN MAVEFORM LIGNER DIN MEST?',
      'stomach_flat': 'Flad',
      'stomach_average': 'Gennemsnitlig',
      'stomach_round': 'Afrundet',

      // Étape 3
      'step3_title': 'HVILKEN HOFTEFORM LIGNER DIN MEST?',
      'hips_narrow': 'Smalle',
      'hips_average': 'Gennemsnitlige',
      'hips_curved': 'Kurvede',

      // Étape 4
      'step4_title': 'HVILKEN BALDEFORM LIGNER DIN MEST?',
      'seat_flat': 'Flade',
      'seat_average': 'Gennemsnitlige',
      'seat_round': 'Runde',

      // Étape 5
      'step5_title': 'VÆLG DIN BH-STØRRELSE',
      'region_eu': 'EUROPA (FR, IT, ES, DE)',
      'region_uk': 'STORBRITANNIEN',
      'region_us': 'USA',
      'region_aus': 'AUSTRALIEN',
      'band_size': 'UNDERBRYSTMÅL',
      'cup_size': 'SKÅLSTØRRELSE',

      // Étape 6
      'step6_title': 'VÆLG DIN SÆDVANLIGE TRUSSESTØRRELSE',
      'size': 'STØRRELSE',
      'see_recommendation': 'Se min anbefaling',

      // Étape 7
      'step7_title': 'DIN PERFEKTE STØRRELSE',
      'size_label': 'STØRRELSE:',
      'top_size': 'OVERDEL:',
      'bottom_size': 'UNDERDEL:',
      'body_explanation': 'Til en body anbefaler vi en størrelse, der passer perfekt til din figur.',
      'social_proof_body': 'Kunder med din figur vælger denne størrelse',
      'social_proof_ensemble': 'Kunder med din figur vælger disse størrelser til deres sæt',
      'edit_answers': 'Rediger mine svar',
      'continue': 'Fortsæt',
      'step7_title_body': 'DIN PERFEKTE BODY-STØRRELSE',
      'apply_size': 'Anvend denne størrelse',
      'apply_size_aria': 'Anvend størrelsen',

      // Messages d'erreur et de validation
      'fill_all_fields': 'Udfyld venligst alle felter korrekt.',
      'select_option': 'Vælg venligst en mulighed.',
      'select_band_cup': 'Vælg venligst et underbrystmål og en skålstørrelse.',
      'select_bottom_size': 'Vælg venligst en trussestørrelse.'
    },

    // Suédois
    'sv': {
      // Général
      'calculate_size': 'Beräkna min storlek',
      'brand_name': 'NAKED UNDERWEAR',
      'next': 'Nästa',
      'previous': 'Tillbaka',
      'close': 'Stäng',

      // Bouton d'affichage de taille
      'size_button_with_size': 'Din perfekta storlek för detta set är',
      'size_button_with_body_size': 'Din perfekta storlek för denna body är',

      // Texte de taille sur la page produit
      'size_notice': 'Din perfekta storlek för detta set är',
      'size_notice_body': 'Din perfekta storlek för denna body är',

      // Unités
      'cm': 'cm',
      'feet': 'fot',
      'kg': 'kg',
      'lbs': 'pund',
      'years': 'år',

      // Étape 1
      'step1_title': 'FYLL I FÖLJANDE UPPGIFTER:',
      'height': 'LÄNGD',
      'weight': 'VIKT',
      'age': 'ÅLDER',

      // Étape 2
      'step2_title': 'VILKEN MAGFORM LIKNAR DIN MEST?',
      'stomach_flat': 'Platt',
      'stomach_average': 'Genomsnittlig',
      'stomach_round': 'Rundad',

      // Étape 3
      'step3_title': 'VILKEN HÖFTFORM LIKNAR DIN MEST?',
      'hips_narrow': 'Smala',
      'hips_average': 'Genomsnittliga',
      'hips_curved': 'Kurviga',

      // Étape 4
      'step4_title': 'VILKEN RUMPFORM LIKNAR DIN MEST?',
      'seat_flat': 'Platta',
      'seat_average': 'Genomsnittliga',
      'seat_round': 'Runda',

      // Étape 5
      'step5_title': 'VÄLJ DIN BH-STORLEK',
      'region_eu': 'EUROPA (FR, IT, ES, DE)',
      'region_uk': 'STORBRITANNIEN',
      'region_us': 'USA',
      'region_aus': 'AUSTRALIEN',
      'band_size': 'UNDERBYSTMÅTT',
      'cup_size': 'KUPSTORLEK',

      // Étape 6
      'step6_title': 'VÄLJ DIN VANLIGA TROSSTORLEK',
      'size': 'STORLEK',
      'see_recommendation': 'Se min rekommendation',

      // Étape 7
      'step7_title': 'DIN PERFEKTA STORLEK',
      'size_label': 'STORLEK:',
      'top_size': 'ÖVERDEL:',
      'bottom_size': 'UNDERDEL:',
      'body_explanation': 'För en body rekommenderar vi en storlek som passar din figur perfekt.',
      'social_proof_body': 'Kunder med din figur väljer denna storlek',
      'social_proof_ensemble': 'Kunder med din figur väljer dessa storlekar till sitt set',
      'edit_answers': 'Redigera mina svar',
      'continue': 'Fortsätt',
      'step7_title_body': 'DIN PERFEKTA BODY-STORLEK',
      'apply_size': 'Använd denna storlek',
      'apply_size_aria': 'Använd storleken',

      // Messages d'erreur et de validation
      'fill_all_fields': 'Fyll i alla fält korrekt.',
      'select_option': 'Välj ett alternativ.',
      'select_band_cup': 'Välj ett underbystmått och en kupstorlek.',
      'select_bottom_size': 'Välj en trosstorlek.'
    },

    // Italien
    'it': {
      // Général
      'calculate_size': 'Calcola la mia taglia',
      'brand_name': 'NAKED UNDERWEAR',
      'next': 'Successivo',
      'previous': 'Precedente',
      'close': 'Chiudi',
      
      // Bouton d'affichage de taille
      'size_button_with_size': 'La tua taglia perfetta per questo set è',
      'size_button_with_body_size': 'La tua taglia perfetta per questo body è',
      
      // Texte de taille sur la page produit
      'size_notice': 'La tua taglia perfetta per questo set è',
      'size_notice_body': 'La tua taglia perfetta per questo body è',
      
      // Unités
      'cm': 'cm',
      'feet': 'piedi',
      'kg': 'kg',
      'lbs': 'libbre',
      'years': 'anni',
      
      // Étape 1
      'step1_title': 'INSERISCI LE SEGUENTI INFORMAZIONI:',
      'height': 'ALTEZZA',
      'weight': 'PESO',
      'age': 'ETÀ',
      
      // Étape 2
      'step2_title': 'QUALE FORMA DI STOMACO ASSOMIGLIA DI PIÙ ALLA TUA?',
      'stomach_flat': 'Piatto',
      'stomach_average': 'Medio',
      'stomach_round': 'Arrotondato',
      
      // Étape 3
      'step3_title': 'QUALE FORMA DI FIANCHI ASSOMIGLIA DI PIÙ ALLA TUA?',
      'hips_narrow': 'Stretti',
      'hips_average': 'Medi',
      'hips_curved': 'Curvi',
      
      // Étape 4
      'step4_title': 'QUALE FORMA DI GLUTEI ASSOMIGLIA DI PIÙ ALLA TUA?',
      'seat_flat': 'Piatti',
      'seat_average': 'Medi',
      'seat_round': 'Rotondi',
      
      // Étape 5
      'step5_title': 'SELEZIONA LA TUA TAGLIA DI REGGISENO',
      'region_eu': 'EUROPA (FR, IT, ES, DE)',
      'region_uk': 'REGNO UNITO',
      'region_us': 'STATI UNITI',
      'region_aus': 'AUSTRALIA',
      'band_size': 'CIRCONFERENZA SOTTOSENO',
      'cup_size': 'TAGLIA COPPA',
      
      // Étape 6
      'step6_title': 'SELEZIONA LA TUA TAGLIA ABITUALE DI SLIP',
      'size': 'TAGLIA',
      'see_recommendation': 'Vedi la mia raccomandazione',
      
      // Étape 7
      'step7_title': 'LA TUA TAGLIA PERFETTA',
      'size_label': 'TAGLIA:',
      'top_size': 'SUPERIORE:',
      'bottom_size': 'INFERIORE:',
      'body_explanation': 'Per un body, raccomandiamo una taglia che si adatti perfettamente alla tua forma del corpo.',
      'social_proof_body': 'I clienti con la tua forma del corpo scelgono questa taglia',
      'social_proof_ensemble': 'I clienti con la tua forma del corpo scelgono queste taglie per il loro set',
      'edit_answers': 'Modifica le mie risposte',
      'continue': 'Continua',
      
      // Messages d'erreur et de validation
      'fill_all_fields': 'Compila correttamente tutti i campi.',
      'select_option': 'Seleziona un\'opzione.',
      'select_band_cup': 'Seleziona una circonferenza sottoseno e una taglia di coppa.',
      'select_bottom_size': 'Seleziona una taglia di slip.'
    }
  };
  
  // Détecter la langue actuelle
  const currentLanguage = detectLanguage();
  
  // Fonction pour obtenir une traduction
  function getTranslation(key) {
    return (translations[currentLanguage] && translations[currentLanguage][key]) || 
           (translations['en'][key]) || key;
  }
  
  // Fonction pour traduire les éléments du widget
  function translateWidgetElements() {
    // Bouton principal
    const sizeButton = document.getElementById('naked-size-button');
    if (sizeButton && !sizeButton.classList.contains('with-size')) {
      sizeButton.textContent = getTranslation('calculate_size');
    } else if (sizeButton && sizeButton.classList.contains('with-size')) {
      // Traduire le bouton avec taille
      const buttonText = sizeButton.textContent || '';
      if (buttonText.includes('body')) {
        const sizeMatch = buttonText.match(/(\w+)$/);
        if (sizeMatch && sizeMatch[1]) {
          const size = sizeMatch[1];
          sizeButton.innerHTML = `${getTranslation('size_button_with_body_size')} <span class="size-result">${size}</span>`;
        }
      } else {
        const sizeMatch = buttonText.match(/(\w+\/\w+)$/);
        if (sizeMatch && sizeMatch[1]) {
          const sizes = sizeMatch[1];
          sizeButton.innerHTML = `${getTranslation('size_button_with_size')} <span class="size-result">${sizes}</span>`;
        }
      }
    }
    
    // Traduire le branding
    const brandingEl = document.querySelector('.naked-size-branding');
    if (brandingEl) {
      brandingEl.textContent = getTranslation('brand_name');
    }
    
    // Traduire les titres des étapes
    for (let i = 1; i <= 7; i++) {
      const titleEl = document.querySelector(`.naked-size-step[data-step="${i}"] .naked-size-step-title`);
      if (titleEl) {
        titleEl.textContent = getTranslation(`step${i}_title`);
      }
    }
    
    // Traduire les étiquettes des champs étape 1
    document.querySelectorAll('.naked-size-step[data-step="1"] label').forEach(label => {
      if (label.getAttribute('for') === 'naked-size-height') {
        label.textContent = getTranslation('height');
      }
      if (label.getAttribute('for') === 'naked-size-weight') {
        label.textContent = getTranslation('weight');
      }
      if (label.getAttribute('for') === 'naked-size-age') {
        label.textContent = getTranslation('age');
      }
    });
    
    // Traduire les unités
    document.querySelectorAll('.naked-size-unit').forEach(unit => {
      const unitType = unit.getAttribute('data-unit');
      if (unitType) {
        unit.textContent = getTranslation(unitType);
      }
    });
    
    // Traduire l'étiquette des années
    const ageLabel = document.querySelector('.naked-size-unit-label');
    if (ageLabel) {
      ageLabel.textContent = getTranslation('years');
    }
    
    // Traduire les options morphologiques (étapes 2-4)
    document.querySelectorAll('.naked-size-step[data-step="2"] .naked-size-morphology-option').forEach(option => {
      const value = option.getAttribute('data-value');
      const label = option.querySelector('.naked-size-morphology-label');
      if (label) {
        if (value === 'flat') label.textContent = getTranslation('stomach_flat');
        if (value === 'average') label.textContent = getTranslation('stomach_average');
        if (value === 'round') label.textContent = getTranslation('stomach_round');
      }
    });
    
    document.querySelectorAll('.naked-size-step[data-step="3"] .naked-size-morphology-option').forEach(option => {
      const value = option.getAttribute('data-value');
      const label = option.querySelector('.naked-size-morphology-label');
      if (label) {
        if (value === 'narrow') label.textContent = getTranslation('hips_narrow');
        if (value === 'average') label.textContent = getTranslation('hips_average');
        if (value === 'curved') label.textContent = getTranslation('hips_curved');
      }
    });
    
    document.querySelectorAll('.naked-size-step[data-step="4"] .naked-size-morphology-option').forEach(option => {
      const value = option.getAttribute('data-value');
      const label = option.querySelector('.naked-size-morphology-label');
      if (label) {
        if (value === 'flat') label.textContent = getTranslation('seat_flat');
        if (value === 'average') label.textContent = getTranslation('seat_average');
        if (value === 'round') label.textContent = getTranslation('seat_round');
      }
    });
    
    // Traduire les sélecteurs de région (étapes 5 et 6)
    const braSizeSystem = document.getElementById('bra-size-system');
    if (braSizeSystem) {
      Array.from(braSizeSystem.options).forEach(option => {
        if (option.value === 'EU') option.textContent = getTranslation('region_eu');
        if (option.value === 'UK') option.textContent = getTranslation('region_uk');
        if (option.value === 'US') option.textContent = getTranslation('region_us');
        if (option.value === 'AUS') option.textContent = getTranslation('region_aus');
      });
    }
    
    const bottomSizeSystem = document.getElementById('bottom-size-system');
    if (bottomSizeSystem) {
      Array.from(bottomSizeSystem.options).forEach(option => {
        if (option.value === 'EU') option.textContent = getTranslation('region_eu');
        if (option.value === 'UK') option.textContent = getTranslation('region_uk');
        if (option.value === 'US') option.textContent = getTranslation('region_us');
        if (option.value === 'AUS') option.textContent = getTranslation('region_aus');
      });
    }
    
    // Traduire les étiquettes de groupe de taille (étape 5)
    document.querySelectorAll('.naked-size-step[data-step="5"] .naked-size-size-group h4').forEach(heading => {
      if (heading.textContent.includes('TOUR DE DOS') ||
          heading.textContent.includes('BAND SIZE') ||
          heading.textContent.includes('UNTERBRUSTUMFANG') ||
          heading.textContent.includes('OMVANG') ||
          heading.textContent.includes('UNDERBRYSTMÅL') ||
          heading.textContent.includes('UNDERBYSTMÅTT') ||
          heading.textContent.includes('CIRCONFERENZA')) {
        heading.textContent = getTranslation('band_size');
      }

      if (heading.textContent.includes('BONNET') ||
          heading.textContent.includes('CUP SIZE') ||
          heading.textContent.includes('KÖRBCHEN') ||
          heading.textContent.includes('CUPMAAT') ||
          heading.textContent.includes('SKÅLSTØRRELSE') ||
          heading.textContent.includes('KUPSTORLEK') ||
          heading.textContent.includes('COPPA')) {
        heading.textContent = getTranslation('cup_size');
      }
    });
    
    // Traduire les étiquettes de groupe de taille (étape 6)
    document.querySelectorAll('.naked-size-step[data-step="6"] .naked-size-size-group h4').forEach(heading => {
      if (heading.textContent.includes('TAILLE') ||
          heading.textContent.includes('SIZE') ||
          heading.textContent.includes('GRÖSSE') ||
          heading.textContent.includes('MAAT') ||
          heading.textContent.includes('STØRRELSE') ||
          heading.textContent.includes('STORLEK') ||
          heading.textContent.includes('TAGLIA')) {
        heading.textContent = getTranslation('size');
      }
    });
    
    // Traduire les étiquettes de résultat (étape 7)
    const bodySizeLabel = document.querySelector('.naked-size-result-body h4');
    if (bodySizeLabel) {
      const span = bodySizeLabel.querySelector('span');
      if (span) {
        const size = span.textContent;
        bodySizeLabel.innerHTML = getTranslation('size_label') + ' <span id="naked-size-body-size">' + size + '</span>';
      }
    }
    
    const topSizeLabel = document.querySelector('.naked-size-result-ensemble .naked-size-recommendation-top h4');
    if (topSizeLabel) {
      const span = topSizeLabel.querySelector('span');
      if (span) {
        const size = span.textContent;
        topSizeLabel.innerHTML = getTranslation('top_size') + ' <span id="naked-size-top-size">' + size + '</span>';
      }
    }
    
    const bottomSizeLabel = document.querySelector('.naked-size-result-ensemble .naked-size-recommendation-bottom h4');
    if (bottomSizeLabel) {
      const span = bottomSizeLabel.querySelector('span');
      if (span) {
        const size = span.textContent;
        bottomSizeLabel.innerHTML = getTranslation('bottom_size') + ' <span id="naked-size-bottom-size">' + size + '</span>';
      }
    }
    
    // Traduire l'explication pour le body
    const bodyExplanation = document.querySelector('.naked-size-body-explanation');
    if (bodyExplanation) {
      bodyExplanation.textContent = getTranslation('body_explanation');
    }
    
    // IMPORTANT: Traduire les messages de preuve sociale
    const bodySocialProof = document.getElementById('naked-size-body-social-proof');
    const ensembleSocialProof = document.getElementById('naked-size-ensemble-social-proof');
    
    if (bodySocialProof) {
      bodySocialProof.textContent = getTranslation('social_proof_body');
    }
    
    if (ensembleSocialProof) {
      ensembleSocialProof.textContent = getTranslation('social_proof_ensemble');
    }
    
    // Traduire les boutons de navigation
    document.querySelectorAll('.naked-size-next-btn').forEach(btn => {
      if (btn.id === 'step6-next') {
        btn.textContent = getTranslation('see_recommendation');
      } else {
        btn.textContent = getTranslation('next');
      }
    });
    
    document.querySelectorAll('.naked-size-prev-btn').forEach(btn => {
      btn.textContent = getTranslation('previous');
    });
    
    document.querySelectorAll('.naked-size-edit-btn').forEach(btn => {
      btn.textContent = getTranslation('edit_answers');
    });
    
    // IMPORTANT: Traduire le bouton Continuer
    document.querySelectorAll('.naked-size-apply-btn').forEach(btn => {
      btn.textContent = getTranslation('continue');
    });
  }
  
  // Fonction pour traduire le texte "Votre taille parfaite pour cet ensemble est S/S" sur la page produit
  function translateProductPageText() {
    // Rechercher tous les éléments qui pourraient contenir ce texte
    const elements = document.querySelectorAll('h1, h2, h3, h4, h5, h6, p, div, span');
    
    elements.forEach(element => {
      // Ne traiter que les éléments sans enfants ou avec uniquement du texte
      if (element.childElementCount === 0) {
        const text = element.textContent.trim();
        
        // Vérifier si le texte correspond au modèle "Votre taille parfaite pour cet ensemble est X/Y"
        if (text.startsWith('Votre taille parfaite pour cet ensemble est')) {
          const sizeMatch = text.match(/(\w+\/\w+)$/);
          if (sizeMatch && sizeMatch[1]) {
            const size = sizeMatch[1];
            element.textContent = `${getTranslation('size_notice')} ${size}`;
          }
        }
        // Vérifier si le texte correspond au modèle "Votre taille parfaite pour ce body est X"
        else if (text.startsWith('Votre taille parfaite pour ce body est')) {
          const sizeMatch = text.match(/(\w+)$/);
          if (sizeMatch && sizeMatch[1]) {
            const size = sizeMatch[1];
            element.textContent = `${getTranslation('size_notice_body')} ${size}`;
          }
        }
      }
    });
  }
  
  // Fonction pour corriger les éléments critiques (messages de preuve sociale et bouton Continuer)
  function fixCriticalElements() {
    // Corriger le message de preuve sociale
    const bodySocialProof = document.getElementById('naked-size-body-social-proof');
    const ensembleSocialProof = document.getElementById('naked-size-ensemble-social-proof');
    
    if (bodySocialProof) {
      bodySocialProof.textContent = getTranslation('social_proof_body');
    }
    
    if (ensembleSocialProof) {
      ensembleSocialProof.textContent = getTranslation('social_proof_ensemble');
    }
    
    // Corriger le bouton Continuer
    const continueBtn = document.getElementById('step7-apply');
    if (continueBtn) {
      continueBtn.textContent = getTranslation('continue');
    }
  }
  
  // Fonction d'initialisation principale
  function initializeTranslations() {
    // Traduire les éléments du widget
    translateWidgetElements();
    
    // Traduire le texte sur la page produit
    translateProductPageText();
    
    // Surcharger les fonctions spécifiques
    extendNAKEDSizeRecommender();
  }
  
  // Extension des méthodes du widget
  function extendNAKEDSizeRecommender() {
    // Surcharger la méthode showResults pour corriger les éléments critiques
    if (window.NAKEDSizeRecommender && window.NAKEDSizeRecommender.prototype.showResults) {
      const originalShowResults = window.NAKEDSizeRecommender.prototype.showResults;
      window.NAKEDSizeRecommender.prototype.showResults = function() {
        // Appeler la méthode originale
        originalShowResults.apply(this, arguments);
        
        // Puis corriger les éléments critiques
        setTimeout(fixCriticalElements, 100);
      };
    }
    
    // Surcharger updateButtonText pour la traduction du bouton d'affichage de taille
    if (window.updateButtonText) {
      const originalUpdateButtonText = window.updateButtonText;
      window.updateButtonText = function() {
        // Appeler la fonction originale
        originalUpdateButtonText.apply(this, arguments);
        
        // Puis traduire le bouton
        setTimeout(() => {
          const sizeButton = document.getElementById('naked-size-button');
          if (sizeButton && sizeButton.classList.contains('with-size')) {
            const buttonText = sizeButton.textContent || '';
            if (buttonText.includes('body')) {
              const sizeMatch = buttonText.match(/(\w+)$/);
              if (sizeMatch && sizeMatch[1]) {
                const size = sizeMatch[1];
                sizeButton.innerHTML = `${getTranslation('size_button_with_body_size')} <span class="size-result">${size}</span>`;
              }
            } else {
              const sizeMatch = buttonText.match(/(\w+\/\w+)$/);
              if (sizeMatch && sizeMatch[1]) {
                const sizes = sizeMatch[1];
                sizeButton.innerHTML = `${getTranslation('size_button_with_size')} <span class="size-result">${sizes}</span>`;
              }
            }
          }
        }, 100);
      };
    }
    
    // Surcharger la méthode validateStep1
    if (window.NAKEDSizeRecommender && window.NAKEDSizeRecommender.prototype.validateStep1) {
      const originalValidateStep1 = window.NAKEDSizeRecommender.prototype.validateStep1;
      window.NAKEDSizeRecommender.prototype.validateStep1 = function() {
        const result = originalValidateStep1.apply(this, arguments);
        if (!result) {
          alert(getTranslation('fill_all_fields'));
          return false;
        }
        return result;
      };
    }
  }
  
  // Rendre les fonctions et données disponibles globalement
  window.NAKED_SIZE_TRANSLATIONS = {
    currentLanguage: currentLanguage,
    translations: translations,
    getTranslation: getTranslation,
    initialize: initializeTranslations,
    translateWidgetElements: translateWidgetElements,
    translateProductPageText: translateProductPageText,
    fixCriticalElements: fixCriticalElements
  };
  
  // Initialiser les traductions au chargement du DOM
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initializeTranslations, 300);
  });
  
  // Appliquer également au chargement complet de la page
  window.addEventListener('load', function() {
    // Première vérification après chargement complet
    setTimeout(initializeTranslations, 500);
    
    // Deuxième vérification un peu plus tard pour les éléments dynamiques
    setTimeout(function() {
      fixCriticalElements();
      translateProductPageText();
    }, 1500);
  });
  
  // Vérification périodique des éléments critiques
  let checkCount = 0;
  const criticalElementsCheck = setInterval(function() {
    // Limiter à 10 vérifications (20 secondes)
    if (++checkCount > 10) {
      clearInterval(criticalElementsCheck);
      return;
    }
    
    // Vérifier si le message de preuve sociale est non traduit
    const socialProof = document.getElementById('naked-size-ensemble-social-proof');
    if (socialProof && socialProof.textContent.includes('Nos clientes') && currentLanguage !== 'fr') {
      fixCriticalElements();
    }
    
    // Vérifier si le bouton Continuer est non traduit
    const continueBtn = document.getElementById('step7-apply');
    if (continueBtn && continueBtn.textContent === 'Continuer' && currentLanguage !== 'fr') {
      fixCriticalElements();
    }
    
    // Vérifier si le texte de la page produit est non traduit
    const productText = document.querySelector('h1, h2, h3, h4, h5, h6, p, div, span');
    if (productText && productText.textContent.includes('Votre taille parfaite pour cet ensemble est') && currentLanguage !== 'fr') {
      translateProductPageText();
    }
  }, 2000);
  
  // Observer les mutations pour détecter les éléments dynamiques
  const observer = new MutationObserver(function(mutations) {
    let needsTranslation = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i];
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Vérifier si cet élément contient des textes à traduire
            if (node.id === 'naked-size-body-social-proof' || 
                node.id === 'naked-size-ensemble-social-proof' || 
                node.id === 'step7-apply' ||
                node.textContent.includes('Votre taille parfaite pour cet ensemble est') ||
                node.textContent.includes('Votre taille parfaite pour ce body est')) {
              needsTranslation = true;
              break;
            }
          }
        }
      }
    });
    
    if (needsTranslation) {
      fixCriticalElements();
      translateProductPageText();
    }
  });
  
  // Observer le corps du document pour les éléments dynamiques
  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    characterData: true
  });
  
  // Arrêter l'observateur après 60 secondes pour économiser les ressources
  setTimeout(function() {
    observer.disconnect();
  }, 60000);
})();

/**
 * Amélioration pour la première étape - Activer le bouton Suivant même si les curseurs
 * n'ont pas été déplacés par l'utilisateur
 */

// Fonction pour activer le bouton Suivant de la première étape
function enableFirstStepButton() {
  // Sélectionner le bouton Suivant de l'étape 1
  const nextButton = document.getElementById('step1-next');
  if (nextButton) {
    // Activer le bouton
    nextButton.classList.add('active');
    nextButton.removeAttribute('disabled');
    
    console.log('Bouton étape 1 activé par défaut');
  }
  
  // S'assurer également que les champs ont bien leurs valeurs par défaut
  const heightInput = document.getElementById('naked-size-height');
  const weightInput = document.getElementById('naked-size-weight');
  const ageInput = document.getElementById('naked-size-age');
  
  // Vérifier et définir les valeurs par défaut si nécessaire
  if (heightInput && !heightInput.value) heightInput.value = '160';
  if (weightInput && !weightInput.value) weightInput.value = '60';
  if (ageInput && !ageInput.value) ageInput.value = '30';
  
  // Déclencher des événements pour s'assurer que les changements sont détectés
  [heightInput, weightInput, ageInput].forEach(input => {
    if (input) {
      const event = new Event('input', { bubbles: true });
      input.dispatchEvent(event);
    }
  });
}

// Si NAKEDSizeRecommender existe, modifions sa méthode d'initialisation
if (window.NAKEDSizeRecommender) {
  // Surcharger la méthode d'initialisation pour activer le bouton dès le départ
  const originalInit = window.NAKEDSizeRecommender.prototype.init;
  if (originalInit) {
    window.NAKEDSizeRecommender.prototype.init = function() {
      // Appeler la méthode d'initialisation originale
      originalInit.apply(this, arguments);
      
      // Puis activer le bouton après un court délai
      setTimeout(enableFirstStepButton, 300);
    };
  }
  
  // Surcharger également la méthode checkStep1Completion
  const originalCheckStep1 = window.NAKEDSizeRecommender.prototype.checkStep1Completion;
  if (originalCheckStep1) {
    window.NAKEDSizeRecommender.prototype.checkStep1Completion = function() {
      const heightInput = document.getElementById('naked-size-height');
      const weightInput = document.getElementById('naked-size-weight');
      const ageInput = document.getElementById('naked-size-age');
      const nextButton = document.getElementById('step1-next');
      
      if (heightInput && weightInput && ageInput && nextButton) {
        // Permettre des valeurs par défaut
        // Si au moins un champ a été rempli ou tous ont des valeurs par défaut (160, 60, 30)
        const hasDefaultHeight = heightInput.value === '160';
        const hasDefaultWeight = weightInput.value === '60';
        const hasDefaultAge = ageInput.value === '35';
        
        // Toujours activer le bouton si les valeurs sont les valeurs par défaut
        if ((hasDefaultHeight && hasDefaultWeight && hasDefaultAge) ||
            (heightInput.value && weightInput.value && ageInput.value)) {
          nextButton.classList.add('active');
          nextButton.removeAttribute('disabled');
        }
      }
    };
  }
}

// Activer le bouton au chargement du DOM
document.addEventListener('DOMContentLoaded', function() {
  // Première tentative après un court délai
  setTimeout(enableFirstStepButton, 500);
  
  // Seconde tentative après chargement complet
  window.addEventListener('load', function() {
    setTimeout(enableFirstStepButton, 300);
  });
  
  // Tentative supplémentaire pour les cas où le widget se charge plus tard
  setTimeout(enableFirstStepButton, 1500);
});

// Aussi vérifier périodiquement si le bouton n'est pas activé alors qu'il devrait l'être
const checkInterval = setInterval(function() {
  const step1 = document.querySelector('.naked-size-step[data-step="1"]');
  const nextButton = document.getElementById('step1-next');
  
  // Si l'étape 1 est active et que le bouton n'est pas activé
  if (step1 && step1.classList.contains('active') && nextButton && nextButton.hasAttribute('disabled')) {
    enableFirstStepButton();
  }
  
  // Arrêter la vérification après 10 secondes
  setTimeout(function() {
    clearInterval(checkInterval);
  }, 10000);
}, 1000);
}
